import { useTranslate } from '@tolgee/react';
import DecorateTitle from 'components/DecorateTitle';
import SwitchWithText from './SwitchWithText';
import { useState } from 'react';
import chatttSDK from 'services/chattt';
import { isUndefined } from 'lodash-es';

const support = {
  gpu: !isUndefined(chatttSDK?.app?.setGPUEnable),
  accessibility: !isUndefined(chatttSDK?.app?.setAccessibilityEnable),
};

export const OthersSetting = () => {
  const { t } = useTranslate();
  const [enableGPU, setEnableGPU] = useState(chatttSDK?.app?.getGPUEnable?.() ?? false);
  const [enableAccessibility, setEnableAccessibility] = useState(
    chatttSDK?.app?.getAccessibilityEnable?.() ?? false,
  );

  return support.gpu || support.accessibility ? (
    <>
      <DecorateTitle>{t('ViewSystem.system.other.title')}</DecorateTitle>
      {support.gpu && (
        <div className="mb-4">
          <SwitchWithText
            key="enableGPU"
            value={enableGPU}
            title={t('ViewSystem.system.other.enable.gpu')}
            checkedChildren={t('antd.switch.on.text')}
            unCheckedChildren={t('antd.switch.off.text')}
            onChange={(checked) => {
              setEnableGPU(checked);
              chatttSDK?.app?.setGPUEnable?.(checked);
            }}
          />
          <section className="inline-block bg-[var(--fett-bg-info-tip)] rounded mx-auto my-[10px] p-3">
            {t('ViewSystem.system.other.enable.gpu.desc')}
          </section>
        </div>
      )}
      {support.accessibility && (
        <div className="mb-4">
          <SwitchWithText
            key="enableAccessibility"
            value={enableAccessibility}
            title={t('ViewSystem.system.other.enable.accessibility')}
            checkedChildren={t('antd.switch.on.text')}
            unCheckedChildren={t('antd.switch.off.text')}
            onChange={(checked) => {
              setEnableAccessibility(checked);
              chatttSDK?.app?.setAccessibilityEnable?.(checked);
            }}
          />
          <section className="inline-block bg-[var(--fett-bg-info-tip)] rounded mx-auto my-[10px] p-3">
            {t('ViewSystem.system.other.enable.accessibility.desc')}
          </section>
        </div>
      )}
    </>
  ) : null;
};
